import { render } from "./InviteUserPage.vue?vue&type=template&id=61d59a36&ts=true"
import script from "./InviteUserPage.vue?vue&type=script&lang=ts"
export * from "./InviteUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Users/InviteUserPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d59a36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d59a36', __exports__)) {
    api.reload('61d59a36', __exports__)
  }
  
  module.hot.accept("./InviteUserPage.vue?vue&type=template&id=61d59a36&ts=true", () => {
    api.rerender('61d59a36', render)
  })

}


export default __exports__